import {
  Bin,
  EditIcon,
  EllipsisMenu,
  getDefaultLogo,
  IOption,
  Typography,
} from '@weareopenr/component-library';
import styles from './ChannelSummary.module.scss';
import { Dispatch, SetStateAction } from 'react';
import { TVariant } from 'src/types';
import { usePermissions } from 'src/hooks';
import { Logo } from '../Logo/Logo';

interface IChannelSummaryProps {
  channelId: string;
  channelName: string;
  logoUrl?: string;
  onDeleteClick: Dispatch<SetStateAction<string | null>>;
  onChannelModal: (value: TVariant, id?: string) => void;
}

export const ChannelSummary = ({
  channelId,
  channelName,
  logoUrl,
  onDeleteClick,
  onChannelModal,
}: IChannelSummaryProps) => {
  const { canEditExtensions, canUninstallExtensions } = usePermissions();
  const options: IOption[] = [];
  canEditExtensions &&
    options.push({
      id: channelId,
      name: 'Edit',
      onOptionClick: () => onChannelModal('Edit', channelId),
      icon: EditIcon,
    });
  canUninstallExtensions &&
    options.push({
      id: 'delete',
      name: 'Delete',
      onOptionClick: () => onDeleteClick(channelId),
      icon: Bin,
      hoverColour: 'tomato',
    });

  return (
    <div className={styles['channel-content']}>
      <div className={styles['info-container']}>
        <Logo
          src={getDefaultLogo(logoUrl ?? channelName)}
          name={channelName}
          className={styles['logo']}
        />
        <Typography weight="semi-bold">{channelName}</Typography>
      </div>
      {options.length > 0 && <EllipsisMenu options={options} variant="outline" />}
    </div>
  );
};
